/**
 * Percentages of counts — the one place this console does arithmetic on data.
 *
 * It is allowed here because these are integer *counts* (funnel steps, acceptance rates, event
 * rejections), never money. Money is resolved by the API and only ever formatted, never computed:
 * see `lib/money.ts` and the note at the top of it.
 */

/** `a` as a percentage of `b`, to one decimal. A zero denominator is 0%, not NaN or Infinity. */
export function pctOf(a: number, b: number): number {
  return b ? Math.round((a / b) * 1000) / 10 : 0;
}

/** A 0–1 ratio as a whole-percent string, for a rate the API already resolved. */
export function ratioPct(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}
